import { useEffect } from "react";
import { createPortal } from "react-dom";
import { RotateCcw } from "lucide-react";

import { Button } from "@/components/primitives";

interface ResetPageDialogProps {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  confirming?: boolean;
  confirmLabel?: string;
}

export function ResetPageDialog({
  open,
  title,
  description,
  onClose,
  onConfirm,
  confirming = false,
  confirmLabel = "确认重置",
}: ResetPageDialogProps) {
  useEffect(() => {
    if (!open) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !confirming) onClose();
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [confirming, onClose, open]);

  if (!open) return null;
  return createPortal(
    <div
      className="page-reset-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (!confirming && event.target === event.currentTarget) onClose();
      }}
    >
      <section className="page-reset-dialog" role="dialog" aria-modal="true" aria-labelledby="page-reset-title">
        <span className="page-reset-dialog__icon" aria-hidden="true"><RotateCcw /></span>
        <h2 id="page-reset-title">{title}</h2>
        <p>{description}</p>
        <div className="page-reset-dialog__actions">
          <Button type="button" variant="ghost" onClick={onClose} disabled={confirming}>取消</Button>
          <Button type="button" variant="danger" onClick={() => void onConfirm()} disabled={confirming}>
            <RotateCcw /> {confirming ? "正在清理…" : confirmLabel}
          </Button>
        </div>
      </section>
    </div>,
    document.body,
  );
}
